import React, {useState, useEffect} from 'react'
import { useParams } from 'react-router-dom';
import './Account.css';

import Header from '../../sections/Header/Header'
import Footer from '../../sections/Footer/Footer'

import { Auth, setAuth, deleteAuth } from '../../../util/Auth';
import { loginModel } from '../../../services/authService';

import Login from './Login/Login';
import Dashboard from './Dashboard/Dashboard';
import Balance from './Balance/Balance';
import Campaign from './Campaign/Campaign';
import Store from './Store/Store';

const Account = () => {

    const { section, id } = useParams()

    const [loading,setLoading] = useState(true)
    const [isAuthenticated,setIsAuthenticated] = useState(null)

    const handleAuthenticate = async (credentials) => {
        const { accessToken, token, user } = await loginModel(credentials.username, credentials.password)
        setAuth(accessToken, token, user.uuid)
        setIsAuthenticated(true)
        return true
    }

    const handleAuthenticateLogout = () => {
        deleteAuth()
        setIsAuthenticated(false)
    }

    useEffect(() => {
        setIsAuthenticated(Auth())
        setLoading(false)
    }, [])

    return (
        <>
            <Header authenticated={isAuthenticated} />
            {
                !isAuthenticated ? (
                    <Login authenticate={handleAuthenticate} loading={loading} /> )
                : (
                        section === 'balance'?
                         <Balance authenticate={handleAuthenticate} loading={loading} />
                        :

                        section === 'campaigns'?
                         <Campaign modelId={id} />
                        :

                        section === 'store'?
                         <Store />
                        :

                        section === 'ad'?
                         <Campaign modelId={id} />
                        
                        :
                    <Dashboard authenticate={handleAuthenticateLogout} loading={loading} />
            )}
            <Footer authenticated={isAuthenticated} />
        </>
    )
}

export default Account